import { Route, Routes, Outlet } from "react-router-dom";
import TicketLists from "./Tickets";
import TicketListInfo from "./ticketLists/TicketListInfo";
import TicketTask from "./TicketTask";

const TicketIndex = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="lists" element={<TicketLists />} />
        <Route path="/tasks" element={<TicketTask />} />
        <Route
          path="/information/:uuid"
          element={
            <>
              <TicketListInfo />
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default TicketIndex;
